var React = require('react');

function BotPrompt (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20 6V14.4444C20 15.549 19.1046 16.4444 18 16.4444H15.9109V20L11.7404 16.4444H6C4.89543 16.4444 4 15.549 4 14.4444V6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6Z","stroke":"#27394C","strokeWidth":"1.6","key":0}),React.createElement("circle",{"cx":"20","cy":"4","r":"4","fill":"#D80606","key":1})]);
}

BotPrompt.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = BotPrompt;

BotPrompt.default = BotPrompt;
